import ExpressionLayout from "./ExpressionLayout";
import { amberEllis } from "./data";

const AmberEllisPage = () => <ExpressionLayout data={amberEllis} />;

export default AmberEllisPage;
